// Copyright (c) 2017 Deere & Company

import SpaClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-summary';
import t from 'tcomb';

const SpaClaims = t.list(SpaClaimForApproval, 'SpaClaims');

export const getDefaultState = () => new SpaClaims([]);

export default SpaClaims;



// WEBPACK FOOTER //
// ./src/tabm/wip/state/spa-claims.js